import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GET_COMMENTS_BY_USER_ID,
  GET_COMMENTS_BY_WORKFLOW_ID,
  GET_COMMENT_BY_ID,
  ADD_COMMENT,
  GET_LAST_COMMENT
} from "./apiUrls";
import {
  clearUploadedListAttachmentOfComments,
  setAddedNewComment,
} from "redux/commentsReducer";
import { encryptPayload } from "./encrypt";

export const getCommentsByUserId = createAsyncThunk(
  "comments/getCommentsByUserId",
  async (queryObj) => {
    const { userId, start, limit, sortBy, sortOrder } = queryObj;
    const req = GET_COMMENTS_BY_USER_ID(
      userId,
      start,
      limit,
      sortBy,
      sortOrder
    );
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const result = await apiRequest(req, options,true);
      return result;
    } catch (error) {
      throw error;
    }
  }
);

export const getCommentsByWorkFlowId = createAsyncThunk(
  'comments/getCommentsByWorkFlowId',
  async (queryObj) => {
    try {
      const { workflow_id, start, limit, sortBy, sortOrder } = queryObj;
      const req = GET_COMMENTS_BY_WORKFLOW_ID(
        workflow_id,
        start,
        limit,
        sortBy,
        sortOrder
      );
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const response = await apiRequest(req, options, true);
      if (response?.count == 0) {
        throw new Error('Failed to fetch data');
      }
      // const data = await response;
      return response;
    } catch (error) {
      let response = {
        data: [],
        message: error,
        status: "failed"
      }
      // console.log("🚀 ~ file: comments.js:261 ~ error:", error)
      return response;
    }
  }
);

export const getCommentById = createAsyncThunk(
  "comments/getCommentsById",
  async (queryObj) => {
    const req = GET_COMMENT_BY_ID(queryObj.commentId);
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const result = await apiRequest(req, options,true);
      return result;
    } catch (error) {
      throw error;
    }
  }
);

export const addComment = createAsyncThunk(
  "comments/addComment",
  async (data, { dispatch }) => {
    const req = ADD_COMMENT;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...data,
      }),
    };
    try {
      const result = await apiRequest(req, options,true);
      dispatch(setAddedNewComment(true));
      return result;
    } catch (error) {
      throw error;
    }
  }
);


export const uploadAttachmentOfComments = createAsyncThunk(
  "comments/uploadAttachmentOfComments",
  async (data) => {
    const { userId, workflowId, field_name, file, organisation_id , subworkflow_id} = data;
    const req = `${BASE_URL}/workflow/uploadWorkflowFile`;
    let formData = new FormData();
    let userdata = {
      user_id: userId,
      primary_workflow_id: workflowId,
      field_name,
      organisation_id: organisation_id,
      subworkflow_id : subworkflow_id
    };

    let params = {
      body: userdata
    }
    const encryptedBodyRes = await encryptPayload('', params, true, true);
    
    let form = new FormData();
    form.append("data",JSON.stringify(encryptedBodyRes))
    form.append("file",file);
    const options = {
      method: 'POST',
      body: form
    }
    try {
      let response = await encryptPayload(req, options, false, true);
      return response;
    } catch (err) {
      throw err;
    }
  }
);

export const uploadCommentDocument = createAsyncThunk(
  "comments/uploadAttachmentOfComments",
  async (data, { dispatch }) => {
    const req = `${BASE_URL}/workflow/uploadCommentDocuments`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    try {
      const result = await apiRequest(req, options,true);
      // const { status } = result;
      dispatch(clearUploadedListAttachmentOfComments());
      return result;
    } catch (error) {
      throw error;
    }
  }
);

export const editCommentById = createAsyncThunk(
  "comments/editCommentById",
  async (data) => {
    const req = `${BASE_URL}/comments/editCommentById`;
    const encryptedBodyRes = await encryptPayload("", { body: data }, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, true, true);
      return result;
    } catch (error) {
      throw error;
    }
  }
);

export const deleteComment = createAsyncThunk(
  "comments/deleteComment",
  async (data) => {
    const req = `${BASE_URL}/comments/deleteComment`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    try {
      const result = await apiRequest(req, options, true);
      return result;
    } catch (error) {
      throw error;
    }
  }
);

export const deleteAttachments = createAsyncThunk(
  "workflow/deleteAttachments",
  async (data) => {
    const req = `${BASE_URL}/workflow/deleteCommentDocument`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    try {
      const result = await apiRequest(req, options, true);
      return result;
    } catch (error) {
      throw error;
    }
  }
);

export const getLastComment = createAsyncThunk(
  "comments/getLastComment",
  async (queryObj) => {
    const req = GET_LAST_COMMENT(queryObj.workflow_id);
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const result = await apiRequest(req, options,true);
      return result;
    } catch (error) {
      throw error;
    }
  }
);